// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jGRCQ91SfmgRaEDsfT2R{border-bottom:1px solid var(--gray-20);grid-template-columns:1fr 1fr;align-items:center;gap:8px;padding:8px;display:grid}.jGRCQ91SfmgRaEDsfT2R .e3IaR0CaEo0tv1e1QEQ_{padding-left:8px}.jGRCQ91SfmgRaEDsfT2R .e3IaR0CaEo0tv1e1QEQ_ .gB6cT_gWk2gLTaVe_MCE{font-size:13px}.jGRCQ91SfmgRaEDsfT2R .Y0w5qlXSwbcgVl0zSaW4{grid-template-columns:40px 1fr;align-items:center;gap:8px;display:grid}.qYNcsWE5zVA3ucoLrtCK{padding:8px}.d8MQVyMse0p9zkto_O5B{gap:8px;padding:16px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `jGRCQ91SfmgRaEDsfT2R`,
	"label": `e3IaR0CaEo0tv1e1QEQ_`,
	"textLabel": `gB6cT_gWk2gLTaVe_MCE`,
	"right": `Y0w5qlXSwbcgVl0zSaW4`,
	"input": `qYNcsWE5zVA3ucoLrtCK`,
	"actions": `d8MQVyMse0p9zkto_O5B`
};
export default ___CSS_LOADER_EXPORT___;
